import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import { MilesByZipcodeData } from 'interfaces/ISummaryReport'
import { getTopZipCodesTableColumns } from './topZipCodesTableData'
import { ScrollableTable } from 'components'
import strings from 'strings'

const r = strings.SUMMARY_REPORT.RADIUS_OF_OPERATION

interface IMilesByZipCodesTableProps {
  loading: boolean
  hasData: boolean
  data: MilesByZipcodeData[]
}

const MilesByZipCodesTable: React.FC<IMilesByZipCodesTableProps> = ({
  loading,
  hasData,
  data,
}) => {
  const topZipCodes = data.slice(0, Math.min(data.length, 25))
  return (
    <Box
      sx={{
        height: 368,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {loading ? (
        <CircularProgress size={30} />
      ) : !hasData ? (
        <Typography variant="body1" color="text.secondary">
          {r.NO_DATA}
        </Typography>
      ) : (
        <ScrollableTable
          data={topZipCodes}
          columns={getTopZipCodesTableColumns(topZipCodes)}
          height={368}
        />
      )}
    </Box>
  )
}

export default MilesByZipCodesTable
